
import { sortCountriesByPriority } from "@/helpers/helpers";

export default {
  data() {
    return {
      isLoading: false,
      isSuccess: false,
      error: "",

      countries: [],

      form: {
        name: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        city: "",
        address: "",
        zip: "",
        retailerName: "",
        contactPerson: "",
      },
    };
  },

  props: {
    active: Boolean,
    payload: Object,
    accessories: Array,
  },

  computed: {
    countriesList() {
      return sortCountriesByPriority(this.countries).map(
        (item) => item.country
      );
    },
  },

  watch: {
    active(value) {
      if (value && !this.countries.length) {
        this.loadCountries();
      }
    },
  },

  mounted() {
    if (this.active) {
      this.loadCountries();
    }
  },

  methods: {
    async loadCountries() {
      try {
        this.countries = await this.$axios.$get("countries");
      } catch (err) {
        this.__logError(err);
      }
    },

    async recaptcha() {
      try {
        const token = await this.$recaptcha.execute("price_request");
        return token;
      } catch (err) {
        this.__logError(err);
        return null;
      }
    },

    async requestPrice() {
      const result = await this.$refs["form"].validate();

      if (result) {
        this.isLoading = true;
        this.error = "";

        try {
          const token = await this.recaptcha();
          const data = await this.$axios.$post("price-request", {
            user: this.form,
            product: this.payload,
            accessories: this.accessories,
            token,
          });

          if (data?.result) {
            this.isSuccess = true;
            this.$fbq?.("Lead", {
              content_name: "price_request",
              content_ids: [String(this.payload?.id ?? "").trim()].filter(Boolean),
            });
            this.__resetForm(this.form);
            this.__toast("Request sent! Wait for the manager to contact you.");
            this.$emit("close");
            this.$emit("send");
          } else {
            this.error = data?.message || "Internal server error";
          }
        } catch (err) {
          this.__logError(err);

          // A rejected request now answers 4xx with {result:false, message} —
          // "That product is no longer available" is worth showing, and axios
          // throws on those, so reading it here is the only place it surfaces.
          const message = err?.response?.data?.message;

          if (message) {
            this.error = message;
          } else if (err === "Failed to execute") {
            this.error = "Please confirm that you are not a robot";
          } else {
            this.error = "Internal server error";
          }
        }

        this.isLoading = false;
      }
    },
  },
};
